import Api from '../../base/api.typings';
import axiosConfiguration from '@/base/axios-configuration';

class LicencaService {
    async listar(query: Api.App.Server.Licenca.Listar.Query): Promise<Api.App.Server.Licenca.Listar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/licenca/listar', { params: query }).then(e => e.data);
    }

    async listarParaEmpresa(query: Api.App.Server.Licenca.ListarParaEmpresa.Query): Promise<Api.App.Server.Licenca.ListarParaEmpresa.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/licenca/listarparaempresa', { params: query }).then(e => e.data);
    }

    async listarParaProduto(query: Api.App.Server.Licenca.ListarParaProduto.Query): Promise<Api.App.Server.Licenca.ListarParaProduto.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/licenca/listarparaproduto', { params: query }).then(e => e.data);
    }

    async listarParaUsuario(query: Api.App.Server.Licenca.ListarParaUsuario.Query): Promise<Api.App.Server.Licenca.ListarParaUsuario.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/licenca/listarparausuario', { params: query }).then(e => e.data);
    }

    async obterParaEditar(query?: Api.App.Server.Licenca.InserirEditar.Query): Promise<Api.App.Server.Licenca.InserirEditar.Command> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/licenca/obterparaeditar', { params: query }).then(e => e.data);
    }

    async inserir(command: Api.App.Server.Licenca.InserirEditar.Command): Promise<string> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/licenca/inserir', command).then(r => r.data);
    }

    async editar(command: Api.App.Server.Licenca.InserirEditar.Command): Promise<string> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().put('/api/licenca/editar', command);
    }

    async ativar(command: Api.App.Server.Licenca.Ativar.Command): Promise<any> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/licenca/ativar', command);
    }
    
    async inativar(command: Api.App.Server.Licenca.Inativar.Command): Promise<any> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/licenca/inativar', command);
    }

    async alterarLicenca(command: Api.App.Server.Licenca.AlterarLicenca.Command): Promise<any> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/licenca/alterarLicenca', command);
    }
}


export default new LicencaService();